/***
 * @file:
 * @author: chengyuntao
 * @Date: 2020-05-25 18:18:30
 */
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';
import { DictionaryService } from '@ithinkdt/shared/dict';
import { ControlValueAccessorService } from '../../control-value-accessor.service';
import monitor from '../../monitor';
// import { customInputControlValueAccessor } from '../../../utils/form.utils';

@Component({
  selector: 'dt-form-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormRadioComponent),
      multi: true,
    },
  ],
})
export class FormRadioComponent extends ControlValueAccessorService {
  @Input() type;
  value;
  @Input() prop = '';
  @Input() list = [];
  @Input() size = 'default';
  @Input() associate: any; // å³èçæä½
  @Input()
  set dictCode(code: string) {
    this.setList(code);
  }
  @Output() valueChange = new EventEmitter<any>();
  dictConf: any;
  constructor(private settingsSrv: SettingsService, private dictSrv: DictionaryService) {
    super();
    this.dictConf = this.settingsSrv.userConfig['pages'].dictConf || {};
  }
  writeValue(value) {
    if (!this.isFrist) {
      monitor.emit('formValueChange', this.prop);
    } else {
      setTimeout(() => {
        this.selectAssociate({ param: value });
      });
    }
    this.value = value;
    this.updateChanges();
  }
  setList(code: string) {
    if (!code) {
      return;
    }
    this.dictSrv.getDicListByDicCode(code).subscribe((res: any) => {
      if (res.status && res.data) {
        const list = [];
        const parseLable = this.dictConf.label;
        const parseValue = this.dictConf.value;
        res.data.forEach((i) => {
          list.push({
            value: i[parseValue],
            label: i[parseLable],
            disabled: false,
          });
        });
        this.list = list;
      }
    });
  }
  radioChanges() {
    this.updateChanges();
    this.selectAssociate({ param: this.value });
    this.valueChange.emit(this.value);
  }
  // ç»ä»¶å³èåå¨ï¼æ§å¶å¯¹åºç»ä»¶
  selectAssociate(option: { [key: string]: any } = {}) {
    if (Array.isArray(this.associate)) {
      this.associate.forEach((i) => {
        this.setAssociateData(option, i);
      });
    }
  }
  setAssociateData(option: { [key: string]: any } = {}, associate) {
    const prop = associate.prop;
    const param: { [key: string]: any } = option.param;
    // è®¾ç½® prop å¯¹åºç»ä»¶ç value
    if (typeof associate === 'object') {
      monitor.emit('setPropValue', { currentProp: this.prop, targetValue: param, ...associate });
    }
  }
}
